<div class="basin-pb-4 basin-width-100">
    <form [formGroup]="form" class="form-container">

        <div class="basin-display-flex basin-flex-column basin-gap-2 basin-mb-2">
            <span>Map Type</span>
        </div>
        <div class="basin-display-flex basin-flex-row basin-gap-2 basin-flex-wrap">
            <p-radioButton *ngFor="let type of mapTypes" [label]="type.label" [value]="type.value"
                formControlName="fileTypes">
            </p-radioButton>

            <small class="p-error" *ngIf="fileTypesControl.invalid && fileTypesControl.touched">
                Please select at least one map type
            </small>
        </div>
    </form>
</div>

<div class="basin-display-flex basin-justify-content-end basin-width-100">
    <button pButton type="button" (click)="onCancel()" class="p-button-text basin-mr-6">
        Cancel
    </button>

    <button pButton type="submit" (click)="onSave()" [disabled]="form.invalid" class="p-button-text">
        Download
    </button>
</div>